import { ButtonProps, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { Badge, ShoppingCartIcon } from '@/shared/ui';
import { useSubscribeCartStoreWithShallow } from '../hooks/cartStoreHooks';
import useCart from '../hooks/useCart';
import { cartStoreSelectors } from '../selectors';
import CartDrawer from './CartDrawer';

const CartDrawerButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useCart();

  const itemCount = useSubscribeCartStoreWithShallow(cartStoreSelectors.itemsCount);
  const isEmpty = useSubscribeCartStoreWithShallow(cartStoreSelectors.isEmpty);

  return (
    <>
      <Badge
        badgeContent={itemCount}
        colorScheme='success'
        fontSize='xx-small'
        invisible={isEmpty}
        right={3}
        top={2}
        variant='subtle'
      >
        <IconButton
          aria-label={t('store.cart.openCart')}
          icon={<ShoppingCartIcon boxSize={5} />}
          onClick={onOpen}
          {...props}
        />
      </Badge>

      <CartDrawer
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
};

export default CartDrawerButton;
